import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EMyHomeActionTypes {
  UpdateIsExist = 'my-home/update-is-exist',
}

export type TUpdateMyHomeIsExist = ITypedReduxAction<EMyHomeActionTypes.UpdateIsExist, boolean>;

export type TMyHomeActions = TUpdateMyHomeIsExist;
